import { gsap } from 'gsap'
import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  static updateThemeColor() {
    const mainElement = document.querySelector('main[data-theme-color]')

    if (mainElement) {
      const themeColor = mainElement.getAttribute('data-theme-color')
      if (themeColor) {  gsap.to(document.body, {
          '--c': themeColor,
          duration: 1,
          ease: 'power2.out',
          overwrite: true
        })
      }
    }
  }

  init () {
    this.video = this.el
    this.colorTimeline = this.parseColorTimeline()
    this.currentColorIndex = 0
    
    if (this.colorTimeline && this.colorTimeline.length > 0) {
      this.setupVideoListeners()
      this.setInitialColor()
    }
  }

  parseColorTimeline() {
    // Look for the JSON script tag with data-color-timeline attribute
    const scriptTag = document.querySelector('script[data-color-timeline]')
    if (!scriptTag) return null
    
    const timelineData = scriptTag.textContent.trim()
    if (!timelineData) return null
    
    // console.log('Raw timeline data:', timelineData)
    
    try {
      const parsed = JSON.parse(timelineData)
      // console.log('Parsed timeline data:', parsed)
      return parsed
    } catch (error) {
      console.warn('Failed to parse color timeline data:', error)
      console.warn('Raw data was:', timelineData)
      return null
    }
  }

  setupVideoListeners() {
    this.video.addEventListener('play', () => {
      this.startColorTimeline()
    })

    this.video.addEventListener('timeupdate', () => {
      this.updateColorBasedOnTime()
    })

    this.video.addEventListener('ended', () => {
      this.resetToFirstColor()
    })

    this.video.addEventListener('seeking', () => {
      this.updateColorBasedOnTime()
    })
  }

  setInitialColor() {
    if (this.colorTimeline.length > 0) {
      this.updateBodyColor(this.colorTimeline[0].color)
    }
  }

  startColorTimeline() {
    // Reset to first color when video starts playing
    this.currentColorIndex = 0
    if (this.colorTimeline.length > 0) {
      this.updateBodyColor(this.colorTimeline[0].color)
    }
  }

  updateColorBasedOnTime() {
    if (!this.colorTimeline || this.colorTimeline.length === 0) return

    const currentTime = this.video.currentTime
    const duration = this.video.duration

    // Find the appropriate color based on current time
    for (let i = 0; i < this.colorTimeline.length; i++) {
      const timelineItem = this.colorTimeline[i]
      const timePosition = (timelineItem.timeline / 100) * duration // Assuming timeline is percentage (0-100)
      
      if (currentTime >= timePosition) {
        if (i !== this.currentColorIndex) {
          this.currentColorIndex = i
          this.updateBodyColor(timelineItem.color)
        }
      }
    }
  }

  updateBodyColor(color) {
    gsap.to(document.body, {
      '--c': color,
      duration: 1,
      ease: 'power2.out',
      overwrite: true
    })
  }

  resetToFirstColor() {
    if (this.colorTimeline.length > 0) {
      this.currentColorIndex = 0
      this.updateBodyColor(this.colorTimeline[0].color)
    }
  }

  destroy() {
    // Clean up event listeners if needed
    if (this.video) {
      this.video.removeEventListener('play', this.startColorTimeline)
      this.video.removeEventListener('timeupdate', this.updateColorBasedOnTime)
      this.video.removeEventListener('ended', this.resetToFirstColor)
      this.video.removeEventListener('seeking', this.updateColorBasedOnTime)
    }
  }
}
